module.exports = __webpack_public_path__ + "static/media/home.89b37265.svg";